<template>
  <div class="container">
    <EditableTable
        :data="tableData"
        :columnConfigs="columnConfigs"
        style="min-width: 900px;"
        height="90vh"
        @save="onSave"
        @delete="onDelete"
    >
      <template v-slot:sales="props">
        <div v-if=" props.row.edit.includes('OWNER')">
          <el-select
              v-model="props.row.sales"
              filterable
              multiple
              placeholder="请选择"
          >
            <el-option
                v-for="item in saleOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
          <el-button type="mini"
                     @click="updateOwner(props.row)"
          >完成
          </el-button>
        </div>
        <div v-else>
          {{ props.row.ownerTxt }}
          <el-button
              v-if="isAdmin"
              type="mini"
              @click="toggleOwnerEditor(props.row)"
          >編輯
          </el-button>
        </div>
      </template>
    </EditableTable>
  </div>
</template>

<script>
import {accountList, getAuth, userAuthorize, userDel, userEdit, userList, userRspEdit} from "@/api";
import EditableTable from "@/components/EditableTable";
import {InfiniteScroller} from '@/components/infiniteScroller'

export default {
  name: "User",
  components: {EditableTable},
  data() {
    return {
      infiniteScroller: null,
      columnConfigs: [
        {name: 'UID', needLevel: 0, editable: false, alias: '顧客編號', width: '8%'},
        {name: 'NAME', needLevel: 0, editable: false, alias: '姓名', width: '20%'},
        {
          name: 'VIP_LEVEL', needLevel: 0, editable: true, alias: 'VIP 等級', width: '15%', options: [
            {value: 0, label: '未開通'},
            {value: 1, label: '價格 A'},
            {value: 2, label: '價格 G'},
          ]
        },
        {name: 'OWNER', needLevel: 0, editable: true, alias: '負責業務', width: '20%'},
        {name: 'MEMO', needLevel: 0, editable: true, alias: '備註', width: '32%'},
        {name: 'DELETE', needLevel: 2, editable: true, alias: '功能', width: '5%'},
      ],
      tableData: [],
      originSales: [],
      saleOptions: [],
      salesMap: {},
    }
  },
  mounted() {
    const targetNode = document.getElementsByClassName('el-table__body-wrapper')[0]
    this.infiniteScroller = new InfiniteScroller(userList, this.callback, targetNode, 200, 120, 600)

    accountList()
        .then(({LIST}) => {
          this.saleOptions = LIST.map(({EID, NAME}) => {
            return {
              label: NAME,
              value: EID,
            }
          })
          LIST.forEach(({EID, NAME}) => {
            this.salesMap[EID] = NAME
          })

          this.infiniteScroller.start()
        })
  },
  beforeDestroy() {
    this.infiniteScroller.stop()
  },
  computed: {
    isAdmin() {
      return Number(this.auth) === 2
    },
    auth() {
      return getAuth()
    }
  },
  watch: {
    tableData() {
      this.tableData.forEach(el => {
        el.ownerTxt = this.getOwnerTxtFromData(el)
      })
    }
  },
  methods: {
    getOwnerTxtFromData(data) {
      return data.OWNER
          .map(o => o.ENAME)
          .join(',')
    },
    toggleOwnerEditor(row) {
      if (row.edit.findIndex(el => el === 'OWNER') > -1) {
        row.edit.splice(row.edit.findIndex(el => el === 'OWNER'), 1)
      } else {
        row.edit.push('OWNER')
      }
    },
    updateOwner(row) {
      this.toggleOwnerEditor(row)
      const previousSalesData = this.originSales.filter(el => el.UID === row.UID)[0]
      const preOwner = previousSalesData.OWNER
      // 先假設會被刪除
      let result = preOwner.map(el => {
        return {
          EID: el.EID,
          ACT: -1,
        }
      })
      // 和改變的比對
      row.sales.forEach(el => {
        const tmpObj = result.filter(obj => obj.EID === el)[0]
        if (tmpObj !== undefined) {
          tmpObj.ACT = 0
        } else {
          result.push({EID: el, ACT: 1})
        }
      })
      // 過濾為 0 的結果
      result = result.filter(el => el.ACT !== 0)
      if (result.length === 0) return

      // 更新資料
      userRspEdit({UID: row.UID, LIST: result})
          .then(res => {
            const newOwner = row.sales.map(EID => {
              return {
                EID,
                ENAME: this.salesMap[EID]
              }
            })
            row.OWNER = newOwner

            previousSalesData.OWNER = [...row.OWNER]

            this.tableData = [...this.tableData]
            console.log(this.originSales);
            console.log(this.tableData)
            this.$message.success("資料更新成功")
          })
          .catch(e => {
            this.$message.error("資料更新失敗")
          })
    },
    callback({LIST}) {
      try {
        LIST.forEach(item => {
          // UID 轉型
          item.UID = item.UID * 1

          // toggle 編輯狀態
          item.edit = []
          // EID 轉型
          item.OWNER.forEach(el => {
            el.EID *= 1
          })
        })
      } catch (e) {
        console.log('2')
      }

      try {
        LIST.forEach(item => {
          // 去重複
          if (item.OWNER.length > 1) {
            item.OWNER.sort((a, b) => a.EID - b.EID)
            for (let i = item.OWNER.length - 1; i > 0; i--) {
              if (item.OWNER[i].EID === item.OWNER[i - 1].EID) {
                item.OWNER.splice(i, 1)
              }
            }
          }
        })
      } catch (e) {
        console.log(3)
      }

      try {
        LIST.forEach(item => {
          // UI 用的資料
          item.sales = item.OWNER.reduce((sum, el) => {
            sum.push(el.EID)
            return sum
          }, [])
        })
      } catch (e) {
        console.log(e);
      }

      this.msg = ''
      this.tableData = [...this.tableData, ...LIST]
      // copy sales data
      const tmpSalesData = LIST.map(el => {
        return {
          UID: el.UID,
          OWNER: el.OWNER,
        }
      })
      this.originSales = [...this.originSales, ...tmpSalesData]

      return LIST.length === 0
    },
    onSuccess(columnName) {
      this.$message.success(`${columnName} 更新成功`)
    },
    onSave({columnName, columnAlias, data}) {
      const {UID, VIP_LEVEL, MEMO} = data
      let apiPromise
      switch (columnName) {
        case 'VIP_LEVEL':
          apiPromise = userAuthorize({UID, VIP: VIP_LEVEL})
          break
        case 'MEMO':
          // FIXME: EID 的資料目前沒有拿到
          apiPromise = userEdit({UID, EID: UID, MEMO})
          break
      }
      apiPromise.then(() => {
        this.onSuccess(columnAlias)
      })
    },
    onDelete({columnName, data}) {
      const {UID} = data
      this.$confirm('此操作将永久删除该用戶, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
          .then(res => {
            userDel({UID})
                .then(res => {
                  const i = this.tableData.findIndex(el => el.UID === UID)
                  this.originSales.splice(i, 1)
                  this.tableData.splice(i, 1)
                  this.$message.success("用戶刪除成功")
                })
                .catch(e => {
                  this.$message.error("用戶刪除失敗")
                })
          })
    }
  }
}
</script>

<style scoped>
.container {
  width: 100%;
}
</style>
